const about = {
  title: '关于亲亲漫画网',
  breadcrumb: '关于我们',
  hero: {
    title: '亲亲漫画网',
    subtitle: '专注下拉式漫画阅读，让每一部漫画都触手可及',
    description: '我们是一群热爱漫画的年轻人，致力于为中国漫画爱好者打造最优质的下拉式阅读平台。在这里，你可以免费畅享海量日漫、韩漫、国漫资源。',
  },
  brand: {
    title: '品牌故事',
    content1: '亲亲漫画网诞生于对漫画的热爱。我们深知传统翻页阅读方式的痛点——加载卡顿、翻页繁琐、阅读体验割裂。于是我们决定打造一个专注于下拉式阅读的漫画平台。',
    content2: '从最初的小众网站，到如今拥有500万+活跃读者的平台，亲亲漫画网始终秉持一个信念：让漫画阅读回归纯粹的快乐。我们提供最流畅的下拉式阅读体验，无需注册、无需付费，打开就能看。',
    content3: '我们持续优化阅读引擎，确保每部漫画都能以最佳的下拉式呈现方式展现在读者面前。无论是精美的日漫分镜，还是流畅的韩漫条漫，都能在亲亲漫画网找到最适合的阅读姿态。',
  },
  reputation: {
    title: '用户口碑',
    subtitle: '来自500万+漫画爱好者的真实评价',
    items: [
      {
        name: '小明同学',
        avatar: '',
        rating: 5,
        comment: '下拉式阅读真的太爽了！之前在其他网站翻页翻到手酸，亲亲漫画网一口气看完一整话，体验满分！',
      },
      {
        name: '二次元少女',
        avatar: '',
        rating: 5,
        comment: '免费的漫画网站很多，但像亲亲这样阅读体验好的真不多。更新也很快，追更党狂喜！',
      },
      {
        name: '漫迷老张',
        avatar: '',
        rating: 5,
        comment: '从网站上线就在用，见证了亲亲一步一步的成长。现在已经是我的主力看漫工具了，推荐给所有漫友。',
      },
      {
        name: '追漫达人',
        avatar: '',
        rating: 5,
        comment: '资源很全，日漫韩漫国漫都有。最喜欢下拉式这个设计，手机上看特别舒服，躺床上追漫美滋滋。',
      },
    ],
  },
  contact: {
    title: '联系我们',
    subtitle: '有任何问题或建议？欢迎随时联系我们',
    email: '联系邮箱',
    emailValue: 'contact@qinqinmanga.com',
    wechat: '微信公众号',
    wechatValue: '亲亲漫画网',
    feedback: '用户反馈',
    feedbackDesc: '我们非常重视每一位读者的反馈，你的建议将帮助我们变得更好。',
  },
  faq: {
    title: '常见问题',
    subtitle: '快速了解亲亲漫画网的使用方式',
  },
};

export default about;